// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"b10b8ba5","125":"8df91889","138":"197d4243","356":"477e3e67","359":"37d9cb27","789":"2f280850","983":"477a1dc2"}[chunkId] + ".chunk.js";
};